"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTheme = exports.withThemeIsLoading = exports.withThemeObject = exports.useThemeIsLoading = exports.useTheme = exports.ThemeContextProvider = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var flowRight_1 = tslib_1.__importDefault(require("lodash/flowRight"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var ThemeContext = react_1.default.createContext(undefined);
ThemeContext.displayName = "ThemeContext";
var ThemeIsLoadingContext = react_1.default.createContext(undefined);
ThemeIsLoadingContext.displayName = "ThemeIsLoadingContext";
/**
 * Provides the theme object and themeIsLoading flag into context
 *
 * @public
 */
exports.ThemeContextProvider = function (_a) {
    var children = _a.children, theme = _a.theme, themeIsLoading = _a.themeIsLoading;
    return (react_1.default.createElement(ThemeContext.Provider, { value: theme },
        react_1.default.createElement(ThemeIsLoadingContext.Provider, { value: themeIsLoading }, children)));
};
/**
 * Hook for reaching the theme from context
 *
 * You can optionally set a theme override that will be returned if defined.
 * This makes the usage more ergonomic (see the following example).
 *
 * @example
 * ```
 * // instead of
 * const fromContext = useTheme();
 * const effectiveTheme = fromArguments ?? fromContext.
 * // you can write
 * const theme = useTheme(fromArguments);
 * ```
 *
 * @param theme - theme to use instead of context value. If undefined, the context value is used.
 * @public
 */
exports.useTheme = function (theme) {
    var themeFromContext = react_1.default.useContext(ThemeContext);
    return theme !== null && theme !== void 0 ? theme : themeFromContext;
};
/**
 * Hook for reaching the themeIsLoading flag from context
 *
 * @public
 */
exports.useThemeIsLoading = function () {
    return react_1.default.useContext(ThemeIsLoadingContext);
};
/**
 * @internal
 */
function withThemeObject(Component) {
    var ComponentWithInjectedThemeObject = function (props) {
        return (react_1.default.createElement(ThemeContext.Consumer, null, function (theme) { var _a; return react_1.default.createElement(Component, tslib_1.__assign({}, props, { theme: (_a = props.theme) !== null && _a !== void 0 ? _a : theme })); }));
    };
    return sdk_ui_1.wrapDisplayName("withThemeObject", exports.ThemeContextProvider)(ComponentWithInjectedThemeObject);
}
exports.withThemeObject = withThemeObject;
/**
 * @internal
 */
function withThemeIsLoading(Component) {
    var ComponentWithInjectedThemeIsLoading = function (props) {
        return (react_1.default.createElement(ThemeIsLoadingContext.Consumer, null, function (themeIsLoading) { return react_1.default.createElement(Component, tslib_1.__assign({ themeIsLoading: themeIsLoading }, props)); }));
    };
    return sdk_ui_1.wrapDisplayName("withThemeIsLoading", exports.ThemeContextProvider)(ComponentWithInjectedThemeIsLoading);
}
exports.withThemeIsLoading = withThemeIsLoading;
/**
 * Injects both theme object and isThemeLoading flag into component as properties
 *
 * @public
 */
function withTheme(Component) {
    return flowRight_1.default(sdk_ui_1.wrapDisplayName("withContexts"), withThemeObject, withThemeIsLoading)(Component);
}
exports.withTheme = withTheme;
//# sourceMappingURL=Context.js.map